<script>
    import { createEventDispatcher } from 'svelte'
    import { Link, navigate } from 'svelte-routing'
    import { FormGroup, Form, FormText, Input, Label, Button,
        Container, Row, Col,
        Card, CardSubtitle, CardText, CardBody, CardHeader, CardTitle } from 'sveltestrap'

    const dispatch = createEventDispatcher()

    export let agent = null
    export let pageTitle = ''

    let changes = {}

    const track = {
        agent: (field) => {
            changes[field] = agent[field]
        },
        address: (field) => {
            if (!changes['address'])
                changes['address'] = {}
            changes['address'][field] = agent['address'][field]
        }
    }

    const onSave = () => dispatch('submit', changes)

</script>

<Container class="mt-4">
    <Row>
        <Col><Link on:click={() => window.history.back()}><i class="fa fa-arrow-left"></i><span style="margin-left: 8px">Back</span></Link></Col>
    </Row>
    <Row>
        <Col>
            <div class="cardHeader">
                <Card>
                    <CardHeader>
                        <h4 class="float-left">{pageTitle}</h4>
                    </CardHeader>
                    <CardBody>
                            <FormGroup>
                                <Label for="name">Name</Label>
                                <Input id="name" placeholder="Name" bind:value={agent.name} on:change={() => track.agent('name')} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input id="email" placeholder="Email" bind:value={agent.email} on:change={() => track.agent('email')} />
                                <Label for="password">Password</Label>
                                <Input id="password" placeholder="Password" bind:value={agent.password} on:change={() => track.agent('password')} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="address1">Address</Label>
                                <Input id="address1" placeholder="Address 1" bind:value={agent.address.address1} on:change={() => track.address('address1')} />
                                <Label for="address2">Address</Label>
                                <Input id="address2" placeholder="Address 2" bind:value={agent.address.address2} on:change={() => track.address('address2')} />
                                <Label for="postalCode">Postal code</Label>
                                <Input id="postalCode" placeholder="Postal code" bind:value={agent.address.postalCode} on:change={() => track.address('postalCode')} />
                                <Label for="city">City</Label>
                                <Input id="city" placeholder="City" bind:value={agent.address.city} on:change={() => track.address('city')} />
                                <Label for="country">Country</Label>
                                <Input id="country" placeholder="Country" bind:value={agent.address.country} on:change={() => track.address('country')} />
                                <Label for="phone">Phone</Label>
                                <Input id="phone" placeholder="Phone number" bind:value={agent.phoneNumber} on:change={() => track.agent('phoneNumber')} />
                            </FormGroup>
                        <Button color="primary" on:click={onSave}>Save</Button>
                    </CardBody>
                </Card>
            </div>
        </Col>
    </Row>
</Container>